import { gql, useMutation } from '@apollo/client';
import { Button, Form } from 'antd';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ActionType, useAppState } from '../state/AppState';
import ChooseAvatar from './ChooseAvatar';
import EditUserNameAvatar from './EditUserNameAvatar';

enum EditUserStep {
  Main,
  ChooseAvatar,
}

const EDIT_USER_PROPERTIES = gql`
  mutation EditAnonUserFields(
    $displayName: String!
    $partyKey: String
    $hasAcceptedProfile: Boolean
    $avatarFileUpload: String
  ) {
    updateUser(
      userInput: {
        displayName: $displayName
        partyKey: $partyKey
        hasAcceptedProfile: $hasAcceptedProfile
        avatarFileUpload: $avatarFileUpload
      }
    ) {
      user {
        displayName
        hasAcceptedProfile
        avatarUrl
      }
    }
  }
`;

const EditUserInfo = ({ onClose }: { onClose: () => void }) => {
  const { user, logOut, dispatch } = useAppState();
  const { partyKey } = useParams<{ partyKey: string }>();
  const [nameValue, setNameValue] = useState<string>(user?.displayName || '');
  const [tempAvatar, setTempAvatar] = useState<string | null>(null);
  const [updateUserInfo] = useMutation(EDIT_USER_PROPERTIES);
  const [editUserStep, setEditUserStep] = useState<EditUserStep>(EditUserStep.Main);
  const history = useHistory();

  const onSubmit = async () => {
    const resp = await updateUserInfo({
      variables: {
        displayName: nameValue,
        partyKey: (partyKey || '').toLowerCase(),
        avatarFileUpload: tempAvatar,
      },
    });
    const user = resp.data.updateUser.user;
    await dispatch({
      type: ActionType.UpdateUser,
      user,
    });
  };

  return (
    <>
      {editUserStep === EditUserStep.Main && (
        <>
          <Form layout='vertical' onSubmitCapture={() => onSubmit()}>
            <EditUserNameAvatar
              nameValue={nameValue}
              tempAvatar={tempAvatar}
              onNameChange={(name) => setNameValue(name)}
            />
            <div className='onboarding-actions-group' style={{ marginTop: 60 }}>
              <Button
                onClick={async () => {
                  await logOut();
                  history.push('/');
                }}
                style={{ width: '48%', height: 80, border: 'none' }}
                type='dashed'
                size='large'>
                log out
              </Button>
              <Button
                style={{ width: '48%', height: 80, border: 'none' }}
                size='large'
                type='dashed'
                onClick={() => {
                  setEditUserStep(EditUserStep.ChooseAvatar);
                }}>
                choose a
                <br />
                new avatar
              </Button>
            </div>
            <div className='onboarding-actions-group'>
              <Button
                onClick={async () => {
                  onClose();
                }}
                type='dashed'
                style={{ width: '48%', height: 80 }}
                size='large'>
                cancel
              </Button>
              <Button
                onClick={async () => {
                  await onSubmit();
                  onClose();
                }}
                type='primary'
                style={{ width: '48%', height: 80, border: 'none' }}
                size='large'>
                save
              </Button>
            </div>
          </Form>
        </>
      )}
      {editUserStep === EditUserStep.ChooseAvatar && (
        <ChooseAvatar
          onComplete={(base64String: string | null) => {
            setTempAvatar(base64String);
            setEditUserStep(EditUserStep.Main);
          }}
          onCancel={() => setEditUserStep(EditUserStep.Main)}
        />
      )}
    </>
  );
};

export default EditUserInfo;
